<template>
  <div id="app">
    <el-container>
      <el-header>
        <div class="logo">
          <p class="yf_logo"><img src="./assets/img/yf.jpg" alt /></p>
          <p>深圳市宇飞智能科技有限公司</p>
        </div>
        <el-menu
          :default-active="defaultActive"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          :router="router"
        >
          <el-menu-item index="/">首页</el-menu-item>
          <el-menu-item index="/news">新闻资讯</el-menu-item>
          <el-menu-item index="/product">产品中心</el-menu-item>
          <el-menu-item index="/case">经典案例</el-menu-item>
          <el-menu-item index="/goin">走进宇飞</el-menu-item>
          <el-menu-item index="/download">下载文档</el-menu-item>
        </el-menu>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <div class="footer" v-show="isShow">
        <div class="footer-content">
          <ul class="content-nav">
            <li>
              <span>邮箱：info@iyufei.com</span>
              <span>电话：0755-82329271</span>
              <span>地址：深圳市龙华区观澜街道牛湖社区高尔夫大道89号G栋201</span>
            </li>
          </ul>
          <img src="./assets/img/LOGO.png" alt />
        </div>
        <div class="copyright">
          <span>深圳市宇飞智能科技有限公司 @2021 Yufei Intelligent Technology Co., Ltd. <a href="http://beian.miit.gov.cn/" style="color:white">粤ICP备2021084149号</a></span>
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      router: true,
      defaultActive: "/",
      isShow: false,
      defaultUrl:"/"
    };
  },
  methods: {
    handleSelect(key) {
      window.sessionStorage.setItem("routerURL",key)
      this.isShow = this.defaultUrl != key;
      window.sessionStorage.setItem("isShow",this.isShow)
    }
  },
  created(){
    if(window.sessionStorage.getItem("routerURL")){
      this.defaultActive = window.sessionStorage.getItem("routerURL");
    }
    if(window.sessionStorage.getItem('isShow')){
      this.isShow = window.sessionStorage.getItem('isShow')
    }
  },
  watch:{
    $route: {
      handler: function(val, oldVal){
        window.sessionStorage.setItem("routerURL",val.path)
        this.isShow = this.defaultUrl != val.path;
        window.sessionStorage.setItem("isShow",this.isShow)
      },
      // 深度观察监听
      deep: true
    }
  }
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
  background: #cccccc;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 100%;
  margin: 0 auto;
  background-color: #fff;
  border-bottom: 1px solid #dddddd;

  .logo {
    width: 280px;
    height:60px;
    line-height: 60px;
    display: flex;
  }
}
.yf_logo{
  width:50px;
  height:50px;
}
.yf_logo img{
  width:100%;
  height:100%;
}
.el-main {
  padding: 0 !important;
}

.footer {
  width: 100%;
  height: 216px;
  overflow: hidden;
  background-color: #14679f;
  &-content {
    width: 1240px;
    margin: 0 auto;
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    .content-nav {
      display: flex;
      justify-content: space-around;
      li {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        //justify-content: center;
        align-items: flex-start;
        p {
          font-size: 20px;
          color: #d4edff;
          padding: 10px 0;
        }
        span {
          color: #f7f7f7;
          font-weight: 300;
          padding: 5px 0;
        }
      }
    }
    img {
      width: 170px;
      height: 50px;
      padding: 10px;
    }
  }
  .copyright {
    width:1240px;
    margin:0 auto;
    text-align: left;
    height: 30px;
    padding-left:40px;
    // background: #125688;
    span {
      color: #fff;
      line-height: 30px;
    }
  }
}
.footer-content{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top:20px;
}
</style>
